import { Slide } from "@jelly/lesson";

import { task as task03 } from "../../../../../task/course-04/lesson-08/task-03";

const task: Slide = {
  titleHtml:
    "An omnidirectional microphone has a sensitivity of 11 mV/Pa. The RMS output voltage due<br /> to noise is equal to 3.1 µV. Calculate the signal to noise ratio if a 45 dB sound<br /> pressure level is applied to the microphone diaphragm.",
  description: "Select the correct answer.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task03.id,
        },
      },
    },
  },
};

export default task;
